import { Skeleton } from "@/components/ui/skeleton";

export const LoadingState = () => (
    <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
            <Skeleton className="h-8 w-8 rounded-full" />
            <Skeleton className="h-4 w-24" />
        </div>
        <Skeleton className="h-8 w-8 rounded" />
        <Skeleton className="h-8 w-8 rounded" />
    </div>
);

export default LoadingState;